import { createStyles } from 'antd-style'

import { BasicProps } from '@eastcoal/common/types/component'

import { ExternalLink } from './ExternalLink'
import { RightInformation } from './RightInformation'

const useStyles = createStyles(({ token }) => ({
  container: {
    marginBlockStart: token.marginLG,
    backgroundColor: '#E0E0E0'
  }
}))

export const LayoutFooter = ({ className, style }: BasicProps) => {
  const { cx, styles } = useStyles()

  return (
    <footer className={cx(styles.container, className)} style={style}>
      <ExternalLink />
      <RightInformation />
    </footer>
  )
}
